import { getAppUrl, getShareInfo } from '~src/utils/fromShare'
import { mixpanel } from '~src/marketing/mixpanel'

export const gotoApp = () => {
  getShareInfo().then((r) => {
    if (r) {
      mixpanel.track('H5Page_clickBegin', {
        source: r.sourceForMixpanel,
        account: r.userId,
      })
    }
  })
  mixpanel.track('click_TryOrStart', {
    SourceURL: window.location.href, // full url with query params
  })
  window.open(getAppUrl(), '_blank')
}
